import styled from 'styled-components';
import { motion } from 'framer-motion';
import { isConstruction } from 'config';

type ContainerProps = {
  $isLast: boolean;
};

export const Container = styled.div<ContainerProps>`
  padding: 8px 0;
  border-top: ${({ theme }) =>
    isConstruction ? `solid 1px ${theme.colors.grey3}` : 'none'};
  border-bottom: ${({ theme, $isLast }) =>
    isConstruction && $isLast ? `solid 1px ${theme.colors.grey3}` : 'none'};
`;

type SectionButtonProps = {
  $isOpen: boolean;
};

export const SectionButton = styled.button<SectionButtonProps>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: ${isConstruction ? 'flex-end' : 'space-between'};
  flex-direction: ${isConstruction ? 'row-reverse' : 'row'};
  gap: ${isConstruction ? '20px' : '24px'};
  color: ${({ theme }) => theme.colors[isConstruction ? 'black' : 'grey6']};
  background-color: ${({ $isOpen, theme }) => {
    if (isConstruction) {
      return 'transparent';
    }
    return $isOpen ? theme.colors.grey1 : 'transparent';
  }};
  font-size: ${isConstruction ? '24px' : '20px'};
  line-height: 28px;
  font-weight: bold;
  text-transform: ${isConstruction ? 'uppercase' : 'initial'};
  border: none;
  border-radius: 12px;
  padding: 8px 12px;
  margin: 0;

  &:hover {
    background-color: ${({ theme }) => {
      if (isConstruction) {
        return 'transparent';
      }
      return theme.colors.grey1;
    }};
  }
`;

export const ContentContainer = styled(motion.div)`
  height: 100%;
  overflow: hidden;
`;

export const Content = styled.div`
  padding: 24px 12px;
`;
